<template>
  <v-row>
    <v-col cols="12">
      <v-container>
        <navbar :light="false" />
      </v-container>
    </v-col>
    <v-col cols="11">
      <v-container class="px-8">
        <v-row>
          <v-col cols="12" md="4" v-if="!isLoadingHome">
            <v-img height="350" width="100%" :src="home.location ? home.location.image_url : ''">
              <div class="fill-height bottom-gradient"></div>
            </v-img>
          </v-col>
          <v-col cols="12" md="6" v-if="!isLoadingHome">
            <div class="py-4 text-left">
              <div class="text-body-1 font-weight-bold secondary--text">SELECTED PACKAGE:</div>
              <div
                class="text-h5 font-weight-bold black--text"
              >{{ home.location ? home.location.name : "" }}</div>
              <div
                class="grey--text pb-1 lighten-2 text-h6"
              >{{ home.location ? home.location.address : "" }}</div>
              <div class="grey--text pb-1 lighten-2 text-body-1 text-capitalize">{{ home.type }}</div>
              <div class="price--text text-h5 font-weight-bold">{{ formatMoney(home.price) }}</div>
            </div>

            <v-btn
              @click="paymentDialog = true"
              depressed
              tile
              large
              color="primary"
              class="text-none px-5 py-5 mr-3 text-h6"
            >Buy Home</v-btn>
          </v-col>
          <v-col cols="12" md="4" v-if="isLoadingHome">
            <v-skeleton-loader v-bind="attrs" type="image"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="6" v-if="isLoadingHome">
            <v-skeleton-loader v-bind="attrs" type="article"></v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row>
          <homes-dialog
            @openPaystack="paystackOpen"
            :paymentDialog="paymentDialog"
            :toggleHomeDialog="togglePaymentMethodDialog"
            :home="home"
            :isOnboarding="true"
          />
          <hm-paystack
            :isOpen="isPaystackOpen"
            :paystackCallback="paystackCallback"
            :paystackClose="paystackClose"
            :totalAmount="totalAmount"
          />
        </v-row>

        <v-row class="mt-10">
          <v-col cols="12">
            <div class="price--text text-body-1 font-weight-bold pt-10">MOST POPULAR HOMES:</div>
          </v-col>
          <v-col cols="12" md="4" xl="3" v-for="offer in popularHomes" :key="offer.id">
            <offer-card :offer="offer" :isOnboarding="true" />
          </v-col>
          <v-col cols="12" v-if="isLoadingPopular">
            <v-row>
              <v-col cols="12" sm="6" md="3" xl="3" v-for="i in 8" :key="i">
                <v-skeleton-loader
                  :max-width="'100%'"
                  :width="'100%'"
                  v-bind="attrs"
                  height="350"
                  type="image, article, actions"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="!isLoadingPopular & (popularHomes.length == 0)">
            <div class="text-h5 font-weight-medium text-center">No Home Packages yet.</div>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
// import { HomesService } from "@/services/index.js";
import { formatMoney } from "@/utils/helpers";
import OfferCard from "@/components/homes/OfferCard.vue";
import HomesDialog from "@/components/homes/HomesDialog";
import HmPaystack from "@/components/HmPaystack";

export default {
  components: {
    Navbar,
    OfferCard,
    HomesDialog,
    HmPaystack,
  },
  data() {
    return {
      formatMoney,
      home: {},
      isLoadingHome: false,
      isLoadingPopular: false,
      popularHomes: [],
      paymentDialog: null,
      isPaystackOpen: false,
      totalAmount: 0,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 0,
      },
    };
  },
  methods: {
    async getHomeById() {
      this.isLoadingHome = true;

      let homeId = this.$route.params.id;

      try {
        let res = await HomesService.getHomeById(homeId);
        this.isLoadingHome = false;

        this.home = res.package;

        // console.log(res);
      } catch (error) {
        this.isLoadingHome = false;

        // throw error;
      }
    },
    async getPopularHomes() {
      this.isLoadingPopular = true;

      try {
        // let res = await HomesService.getHomeOffers();
        // this.isLoadingPopular = false;

        // this.popularHomes = res.packages;

        // console.log(res);
      } catch (error) {
        this.isLoadingPopular = false;

        // throw error;
      }
    },
    togglePaymentMethodDialog(value) {
      // console.log(value);
      this.paymentDialog = value;
      // this.$store.commit("togglePaymentMethodDialog", value);
    },
    paystackCallback(res) {
      // console.log(res); 
      this.isPaystackOpen = false;
    },
    paystackClose() {
      this.isPaystackOpen = false;
    },
    paystackOpen(total) {
      this.isPaystackOpen = true;
      this.totalAmount = total;
    },
  },
  mounted() {
    this.getHomeById();
    this.getPopularHomes();
  },
};
</script>
